import { render, staticRenderFns } from "./sealManagement.vue?vue&type=template&id=39f63c80&scoped=true&"
import script from "./sealManagement.vue?vue&type=script&lang=js&"
export * from "./sealManagement.vue?vue&type=script&lang=js&"
import style0 from "./sealManagement.vue?vue&type=style&index=0&id=39f63c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f63c80",
  null
  
)

export default component.exports